import { IPlaybookTemplateDetails } from "./playbookTemplateDetails.interface";
import { PlaybookTemplateKey } from "./playbookTemplateKey.enum";
import { Platform } from "../../api/common";

const baseTemplateLabelPath = "playbooksMarketplace.playbookTemplates.";

export const PlaybookTemplatesDetailsModule: IPlaybookTemplateDetails[] = [
    {
        key: PlaybookTemplateKey.powerplatformInsecureCommunication,
        platform: Platform.powerplatform,
        descriptionLabel: baseTemplateLabelPath + "insecureCommunicationDescription",
        subTitleLabel: baseTemplateLabelPath + "insecureCommunicationSubTitle",
        titleLabel: baseTemplateLabelPath + "insecureCommunicationTitle",
    },
    {
        key: PlaybookTemplateKey.powerplatformImplicitSharing,
        platform: Platform.powerplatform,
        descriptionLabel: baseTemplateLabelPath + "implicitSharingDescription",
        subTitleLabel: baseTemplateLabelPath + "implicitSharingSubTitle",
        titleLabel: baseTemplateLabelPath + "implicitSharingTitle",
    },
    {
        key: PlaybookTemplateKey.powerplatformPersonalDataAccess,
        platform: Platform.powerplatform,
        descriptionLabel: baseTemplateLabelPath + "personalDataAccessDescription",
        subTitleLabel: baseTemplateLabelPath + "personalDataAccessSubTitle",
        titleLabel: baseTemplateLabelPath + "personalDataAccessTitle",
    },
    {
        key: PlaybookTemplateKey.powerplatformSuspiciousDataFlow,
        platform: Platform.powerplatform,
        descriptionLabel: baseTemplateLabelPath + "powerplatformSuspiciousDataFlowDescription",
        subTitleLabel: baseTemplateLabelPath + "powerplatformSuspiciousDataFlowSubTitle",
        titleLabel: baseTemplateLabelPath + "suspiciousDataFlowTitle",
    },
    {
        key: PlaybookTemplateKey.powerplatformExternalUsersAccess,
        platform: Platform.powerplatform,
        descriptionLabel: baseTemplateLabelPath + "externalUsersAccessDescription",
        subTitleLabel: baseTemplateLabelPath + "externalUsersAccessSubTitle",
        titleLabel: baseTemplateLabelPath + "externalUsersAccessTitle",
    },
    {
        key: PlaybookTemplateKey.powerplatformCustomConnectorMissingAuthentication,
        platform: Platform.powerplatform,
        descriptionLabel: baseTemplateLabelPath + "customConnectorMissingAuthenticationDescription",
        subTitleLabel: baseTemplateLabelPath + "customConnectorMissingAuthenticationSubTitle",
        titleLabel: baseTemplateLabelPath + "customConnectorMissingAuthenticationTitle",
    },
    {
        key: PlaybookTemplateKey.powerplatformAnonymousAgentTriggerAccess,
        platform: Platform.powerplatform,
        descriptionLabel: baseTemplateLabelPath + "anonymousAgentTriggerAccessDescription",
        subTitleLabel: baseTemplateLabelPath + "anonymousAgentTriggerAccessSubTitle",
        titleLabel: baseTemplateLabelPath + "anonymousAgentTriggerAccessTitle",
    },
    {
        key: PlaybookTemplateKey.workatoInsecureCommunication,
        platform: Platform.workato,
        descriptionLabel: baseTemplateLabelPath + "insecureCommunicationDescription",
        subTitleLabel: baseTemplateLabelPath + "insecureCommunicationSubTitle",
        titleLabel: baseTemplateLabelPath + "insecureCommunicationTitle",
    },
    {
        key: PlaybookTemplateKey.workatoPersonalDataAccess,
        platform: Platform.workato,
        descriptionLabel: baseTemplateLabelPath + "personalDataAccessDescription",
        subTitleLabel: baseTemplateLabelPath + "personalDataAccessSubTitle",
        titleLabel: baseTemplateLabelPath + "personalDataAccessTitle",
    },
    {
        key: PlaybookTemplateKey.workatoSuspiciousDataFlow,
        platform: Platform.workato,
        descriptionLabel: baseTemplateLabelPath + "workatoSuspiciousDataFlowDescription",
        subTitleLabel: baseTemplateLabelPath + "workatoSuspiciousDataFlowSubTitle",
        titleLabel: baseTemplateLabelPath + "suspiciousDataFlowTitle",
    },
];
